import { InjectionToken } from '@angular/core';
import { ComponentLoader } from './component-loader.type';

export const PEDAGOGICAL_WORKFLOW_TAB_COMPONENT_LOADER = new InjectionToken<ComponentLoader>(
  'PEDAGOGICAL_WORKFLOW_TAB_COMPONENT_LOADER'
);
